<section class="library-header" [class.mobile]="deviceService.isMobile()">
  <app-sticky [scrollThreshold]="scrollThreshold"
              [stuckForDesktop]="!deviceService.isMobile()"
              [afterScrollThreshold]="afterScrollThreshold()">
    <div class="title-block-breadcrumbs">
      <ng-template [ngIf]="canBreadcrumbs()" [ngIfElse]="gap">
        <app-breadcrumbs [pageType]="'content'" [displayMode]="'breadCrumbsOnly'"></app-breadcrumbs>
      </ng-template>
      <ng-template #gap>
        <div class="gap"></div>
      </ng-template>
    </div>
    <div class="title-block">
      <div class="title-wrap">
        <h1 class="title">
          <b *ngFor="let title of titles; trackBy: trackByFn" [innerHTML]="title | translate"></b>
          <b *ngIf="titles.length > 0 && (baseTitle | translate) !== ''"> / </b>
          <b>{{ baseTitle | translate }}</b>
        </h1>
      </div>
    </div>

    <ng-template #searchBlock>
      <div class="search-block" [class.on-focus]="isFocus">
        <app-icon class="search-content-icon" icon="search"></app-icon>
        <input type="text"
               class="search-input"
               [(ngModel)]="term"
               (focus)="onFocus()"
               (blur)="onFocus()"
               (change)="onTermChange()"
               (keyup.enter)="onTermChange()"
               [placeholder]="'library.form-term-placeholder-new' | translate">
        <app-icon class="search-icon-close"
                  [class.visible]="!!term"
                  (click)="clearSearchForm()"
                  icon="close-search">
        </app-icon>
      </div>
    </ng-template>

    <div class="action">
      <ng-container *ngIf="isTeacher && onCreateTitle()">
      <ng-template [ngIf]="!isTutorsPage">
        <ng-template [ngIf]="deviceService.isMobile()" [ngIfThen]="action_mobile" [ngIfElse]="action_desktop">
        </ng-template>

        <ng-template #action_desktop>
          <on-ui-button class="primary outline"
                        [attr.data-test]="onCreateTitle() | translate"
                        [label]="onCreateTitle()"
                        (onclick)="onCreated()">
          </on-ui-button>
        </ng-template>

        <ng-template #action_mobile>
          <div class="action-item" (click)="onCreated()">
            <div class="action-icon-wrap">
              <app-icon width="20" height="20" icon="plus"></app-icon>
            </div>
          </div>
        </ng-template>
      </ng-template>
      </ng-container>
    </div>

    <!--<div class="action-block" *ngIf="!!panesList?.length">
      <app-pane *ngFor="let pane of panesList" [item]="pane" (loadFinished)="loadFinished(pane, $event)"></app-pane>
    </div>-->
  </app-sticky>
</section>

<app-modal *ngIf="deviceService.isDesktop() && meetingFormOpen"
           (closed)="onToggleMeetingForm()">
  <app-modal-body>
    <app-meeting-form-wrapper [caller]="'app-library-header-new'"></app-meeting-form-wrapper>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && meetingFormOpen"
                  (closed)="onToggleMeetingForm()">
  <app-mobile-modal-body>
    <app-meeting-form-wrapper [caller]="'app-library-header-new'"></app-meeting-form-wrapper>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal *ngIf="deviceService.isDesktop() && schoolFormOpen"
           (closed)="onToggleSchoolForm()">
  <app-modal-body>
    <app-school-form [modalDisplayMode]="true"
                     (changed)="onToggleSchoolForm()">
    </app-school-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && schoolFormOpen"
                  (closed)="onToggleSchoolForm()">
  <app-mobile-modal-body>
    <app-school-form [modalDisplayMode]="true"
                     (changed)="onToggleSchoolForm()">
    </app-school-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template [ngIf]="openResumePlanModal">
  <app-payment-wizard-dialog [plan]="plan" (closed)="onToggleResumePlan()"></app-payment-wizard-dialog>
</ng-template>
